<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; dislay: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div class="CIT_background">
        <div class="position" style="display: flex; flex-direction: column">
          <div class="container_CIT02">
            <div class="block">
              <Card :imgUrl="baseUrl + content" />
            </div>
            <div class="btn-exit">
              <ButtonIcon
                :bgColor="`#ed8e91`"
                :iconUrl="'close.png'"
                :size="1"
                :url_image="false"
                @click="onClose(navigate.close.action)"
              />
            </div>
          </div>
          <CRow
            style="
              display: flex;
              justify-content: center;
              margin: 0;
              padding: 0;
            "
          >
            <div
              class="button button_setting"
              @click="onNextRoute(navigate.next.action)"
            >
              <CCol col="8">
                <div class="font_size">START</div>
              </CCol>
              <CCol col="2">
                <i class="fas fa-caret-right fa-5x" style=""></i>
              </CCol>
            </div>
          </CRow>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ButtonIcon from "@/components/elements/Buttons/ButtonIcon";
import Card from "@/components/elements/Card";
import LoadingMDL from "@/components/loading/LoadingMDL";
import { mapGetters } from "vuex";

export default {
  components: { ButtonIcon, Card, LoadingMDL },
  name: "CIT02",
  props: {},
  data() {
    return {
      content: [],
      loading: true,
      baseUrl: process.env.VUE_APP_URL_SOUND,
      navigate: [],
      templateData: {},
      startTime: this.$helpers.getDateFormat(),
      condition: [],
      code:"",
      section:"",
    };
  },
  methods: {
    onNextRoute: function () {
      this.loading = true;
      this.$store.dispatch("template/commitUserProgressChinese2", {
        // code: "605418cb883ae722ba1b0c5f",
        code:this.code,
        codeTemplate: this.templateData.templateData.codeTemplate,
        contentId: this.templateData.criteria._id,
        answering: [],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        condition: this.condition,
        chapter:
          this.templateData.chapter == undefined
            ? null
            : this.templateData.chapter,

        topic: this.templateData.topicPosition,
      });
    },
    onClose: function (route) {
      let closeRoute = route.split("-");
      this.$router.push("/" + closeRoute[0] + "/" + closeRoute[1]);
    },
  },
  computed: {
    ...mapGetters({
      getTemplateAndProgress: "template/getTemplateAndProgress",
      getResponseStatus: "template/getResponseStatus",
    }),
  },
  watch: {
    getTemplateAndProgress: async function (value) {
      console.log(value);
      if (value.criteria.condition.criteriaType.length != 0) {
        this.condition.push({
          criteria: value.criteria.condition.criteriaType[0]._id,
          val: value.criteria.condition.criteriaType[0].val,
        });
      }
      this.templateData = value;
      this.navigate = value.templateData.navigate;
      this.content = value.templateData.content.image;
      this.loading = false;
    },
    getResponseStatus: async function (value) {
      if (value.status == 200) {
        let route = this.navigate.next.action.split("-");
        this.$router.push("/" + route[0] + "/" + route[1]);
      }
    },
  },
  created() {
    this.currentRoute = this.$route.name + "-" + this.$route.params.id;
    this.courseData = this.$store.getters["necessary/getLerningCourse"]
    this.code = this.courseData._id;
    this.section = this.$store.getters['necessary/getUserCourseSection']
    console.log(this.section);
  },
  mounted() {
    let payload = {
      templateCode: this.currentRoute,
      // code: "605418cb883ae722ba1b0c5f",
      code:this.code,
      section:this.section
      // section: "testing",
    };
    this.$store.dispatch("template/fetchTemplateAndProgress", payload);
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.CIT_background {
  background-color: #ffdc77;
}
.position {
  margin-top: 3%;
  display: flex;
  align-content: center;
  justify-content: center;
}
.block {
  width: 450px;
  height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 20px;
}
.card {
  width: 400px;
  height: 400px;
  background-color: white;
  border-radius: 20px; /* 5px rounded corners */
  border: 0px solid;
}
.btn-exit {
  right: 34%;
  position: absolute;
  width: 60px;
  height: 60px;
  // margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.container_CIT02 {
  margin-top: 10%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.button_setting {
  background-color: #f1b205;
  color: white;
  text-align: center;
  text-decoration: none;
  font-size: 12px;
  border-radius: 10px !important;
  box-shadow: none;
  margin-top: 6%;
  margin-bottom: 5%;
  width: 250px;
  height: 70px;
}
.font_size {
  font-size: 18px;
}

// resolution mobile
@media screen and (min-width: 300px) and (max-width: 600px) {
  .position {
    padding-top: 20%;
    padding-bottom: 20%;
  }
  .container_CIT02 {
    margin-top: 20%;
  }
  .block {
    margin-top: 20px;
    width: 250px;
    height: 250px;
  }
  .card {
    width: 250px;
    height: 250px;
  }
  .button_setting {
    width: 150px;
    height: 50px;
  }
  .fa-caret-right {
    font-size: 30px;
  }
  .font_size {
    font-size: 12px;
  }
  .btn-exit {
    width: 70px;
    height: 70px;
    padding: 10px;
    right: -1%;
    font-size: 30px;
  }
}
// resolution ipad
@media only screen and (min-width: 700px) and (max-width: 821px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 10%;
  }
}
// resolution ipad pro
@media only screen and (min-width: 1024px) and (max-width: 1025px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 20%;
  }
  .position {
    margin-top: 0;
  }
}
@media only screen and (min-width: 1030px) and (max-width: 1366px) {
  .btn-exit {
    right: 22%;
  }
}
// PC MAX 1800
@media only screen and (min-width: 1366px) and (max-width: 1600px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 32%;
  }
  .position {
    margin-top: 0;
  }
  .button_setting {
    margin-top: 5%;
  }
}
// PC MAX 1600
@media only screen and (min-width: 1366px) and (max-width: 1600px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 28%;
  }
}
// PC MAX 1400
@media only screen and (min-width: 1367px) and (max-width: 1400px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 28%;
  }
}
</style>
